import EmptyPrinterItem from './parts/EmptyPrinterItem'
import PrinterItem from './parts/PrinterItem'
import { Printer } from '@/features/print/types'
import { PrinterActions } from '@/features/settings/components/PrintManagement/types'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

type PrinterListProps = {
    printers: Printer[]
} & PrinterActions

const PrinterList: FC<PrinterListProps> = ({ printers, onEditPrinter, onDeletePrinter }) => {
    if (printers.length === 0) {
        return <EmptyPrinterItem />
    }

    return (
        <View style={styles.list}>
            {printers.map((printer) => (
                <PrinterItem
                    key={printer.id}
                    printer={printer}
                    onEditPrinter={onEditPrinter}
                    onDeletePrinter={onDeletePrinter}
                />
            ))}
        </View>
    )
}

const styles = StyleSheet.create({
    list: {
        width: '100%',
        gap: 12,
        alignItems: 'center',
    },
})

export default PrinterList
